import React, {Component} from 'react';
import {connect} from 'react-redux';

import { withRouter} from 'react-router-dom';
import TextField from 'material-ui/TextField';
import RaisedButton from 'material-ui/RaisedButton';
import { updateUserPassword } from '../../../redux/actions/userAction';

class PasswordReset extends Component {

    constructor(props) {
        super(props);
        this.state = {
            user_profile: false,
            errorTexts : {
                name: false,
                telephone: false,
                email: false,
                password: false,
                password_repeat: false,
            }
        }

        this.updateField = this.updateField.bind(this);
    }
    updateEmail(e) {
        this.setState({
            user_email: e.target.value
        });
    }

    updateField(e, isRequired, sameAs = false) {
        let errorTexts = this.state.errorTexts;

        if(isRequired) {
            if(e.target.value === '') {
                errorTexts[e.target.getAttribute('name')] = "Dit veld is verplicht";
            }else{
                errorTexts[e.target.getAttribute('name')] = false;
            }
        }

        if(sameAs !== false) {

            let thisField = e.target.value;
            let matchField = this.state.user_profile[sameAs];
            if(thisField && matchField) {

                if(e.target.value !== matchField) {
                     errorTexts[e.target.getAttribute('name')] = "Wachtwoorden zijn ongelijk";
                     errorTexts[sameAs] = "Wachtwoorden zijn ongelijk";
                }else{
                    errorTexts[e.target.getAttribute('name')] = false;
                    errorTexts[sameAs] = false;
                }
            }else{
                if(thisField === '' && matchField === '') {
                    errorTexts[e.target.getAttribute('name')] = false;
                    errorTexts[sameAs] = false;
                }else{
                     errorTexts[e.target.getAttribute('name')] = "Wachtwoorden zijn ongelijk";
                errorTexts[sameAs] = "Wachtwoorden zijn ongelijk";
                }

            }
        }

        this.setState({
            user_profile : {
                ...this.state.user_profile,
                [e.target.getAttribute('name')] : e.target.value
            },
            errorTexts
        })
    }

    handleSubmit(e) {
        if(e) {
            e.preventDefault();
        }

        const errors = this.state.errorTexts;
        let user_profile = this.state.user_profile;
        user_profile['user_id'] = this.state.user_id;
        let containsError = false;
        for (let key in errors) {
            if(errors.hasOwnProperty(key)) {
                if(errors[key] !== false) {
                    containsError = true;
                }
            }
        }

        if(!containsError) {
            this.props.updateUserPassword(this.props.clientPath + '/api/user/action/updatepassword', user_profile, false, false, this.state.token, this.props.clientPath);
        }

    }

    mapChildUsers(childUser, key) {

        return(<li key={key}>

            <div className="list__item list__item--col-4">{childUser.name}</div>
            <div className="list__item list__item--col-3">{childUser.email}</div>
            <div className="list__item list__item--col-3">{childUser.phone}</div>

            <div className="list__item list__item--col-2--last"><a href={'/mijn-gebruikers/wijzigen/'+key}>Update</a></div>
        </li>);
    }


    componentDidMount() {
        this.setState({
            user_profile: this.props.user.user_profile,
            user_id: this.props.user.user_id,
            token: this.props.user.user_token
        })

        document.querySelector('title').innerHTML = 'MijnDP - Wachtwoord resetten';
    }
    render() {

        return (
            <div>
                <div className="column column--6">
                    <div className="card">


                        <div className="card__header">
                          <h1>Mijn Profiel</h1>
                        </div>

                        <div className="card__body">
                            <div className="card__content">
                                <p>U logt voor het eerst in of u heeft uw wachtwoord gereset. Daarom is het verplicht een nieuw wachtwoord in te stellen.</p>
                                <p>Het wachtwoord dient tenminste 7 karakters te bevatten.</p>
                                        <form onSubmit={this.handleSubmit}>
                                            {/*<TextField
                                                id="name"
                                                name="name"
                                                floatingLabelText="Naam"
                                                errorText={this.state.errorTexts.name}
                                                fullWidth={true}
                                                required={true}
                                                value={this.state.user_profile ? this.state.user_profile.name : ''}
                                                onChange={(e) => this.updateField(e, true)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />

                                            <TextField
                                                id="telephone"
                                                floatingLabelText="Mobiel"
                                                name="telephone"
                                                fullWidth={true}
                                                errorText={this.state.errorTexts.telephone}
                                                value={this.state.user_profile ? this.state.user_profile.telephone : ''}
                                                onChange={(e) => this.updateField(e, true)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />

                                            <TextField
                                                id="email"
                                                name="email"
                                                floatingLabelText="E-mailadres"
                                                value={this.state.user_profile ? this.state.user_profile.email : ''}
                                                fullWidth={true}
                                                onChange={(e) => this.updateField(e, true)}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />*/}

                                            <TextField
                                                id="password"
                                                name="password"
                                                type="password"
                                                errorText={this.state.errorTexts.password}
                                                floatingLabelText="Wachtwoord"
                                                fullWidth={true}
                                                onChange={(e) => this.updateField(e, false, 'password_repeat')}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />

                                            <TextField
                                                id="password_repeat"
                                                name="password_repeat"
                                                type="password"
                                                floatingLabelText="Wachtwoord herhalen"
                                                errorText={this.state.errorTexts.password_repeat}
                                                fullWidth={true}
                                                onChange={(e) => this.updateField(e, false, 'password')}
                                                onKeyPress={(ev) => {
                                                    if (ev.key === 'Enter') {
                                                        this.handleSubmit()
                                                    }
                                                  }}
                                            />


                                            <div className="floating__button floating__button--right">
                                                <RaisedButton onClick={() => this.handleSubmit()} label="Opslaan" primary={true} fullWidth={true}/>
                                            </div>
                                        </form>



                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

}

function mapStateToProps (state) {
    return {
        user: state.UserReducer,
        clientPath: state.ClientPathReducer.clientPath
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        updateUserPassword: (url, data, childIndex, parentId, token, clientPath) => dispatch(updateUserPassword(url, data, childIndex, parentId, token, clientPath))
    };
};



export default withRouter(connect(mapStateToProps, mapDispatchToProps)(PasswordReset));



// WEBPACK FOOTER //
// ./src/components/User/PasswordReset/index.js